/**
 * Slideshow
 */

window.responsiveLazyLoading = function responsiveLazyLoading() {
    $('.slideWrapper .slide img').each(function () {
        var desktop_slide = $(this).data('desktop'),
            mobile_slide = $(this).data('mobile');

        if (matchesMediaQuery(0, 670)) {
            $(this).attr('data-lazy', mobile_slide);
        } else {
            $(this).attr('data-lazy', desktop_slide);
        }
    });
}

window.slideShow = function slideShow() {
    'use strict';

    if ($('.slideWrapper ul li').length) {

        responsiveLazyLoading();

        var speed = 5000;

        var slider = $('.slides');

        // wait on image loading before autplaying slider
        slider.on('init', function () {
            // ignore clone
            $(this).find('.slide:nth-child(2)').find('picture img').on('load', function () {
                slider.slick('slickPlay');
            });
        });

        slider.slick({
            dots: true,
            infinite: true,
            arrows: false,
            autoplay: false,
            autoplaySpeed: speed,
            // pauseOnHover: false,
            cssEase: 'ease-in',
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 670,
                    settings: {
                        cssEase: 'linear'
                    }
                }
            ]
        });

        slider.on('breakpoint', function () {
            responsiveLazyLoading();
        });

    }
}

window.desktopSlider = function desktopSlider() {

    if (windowWidth > window.breakpoints.mobile) {

        if ($('.slideWrapper.homePage').length || $('.slideWrapper.franchiseSlider').length) {

            var slider_wrap = $('.slideWrapper'),
                page_id = slider_wrap.data('page-id');

            // ajax in and build desktop slider
            $.ajax({
                type: 'post',
                url: '/plugins/Slider/ajax/desktop_slider.php',
                data: {
                    ajax: true,
                    page_id: page_id
                },
                success: function (response) {
                    if (response) {
                        slider_wrap.html(response);
                        slideShow();
                    }
                }
            });
        }
    }
}

window.alternateSlideshow = function alternateSlideshow() {

    if ($('.js_altSliderWrapper ul li').length) {

        var speed = 5000,
            slider = $('.js_altSlides');

        slider.on('init', function () {
            console.log('init');
        });


        slider.slick({
            dots: true,
            infinite: true,
            arrows: false,
            autoplay: false,
            autoplaySpeed: speed,
            // pauseOnHover: false,
            cssEase: 'ease-in',
            lazyLoad: 'progressive',
            responsive: [
                {
                    breakpoint: 670,
                    settings: {
                        cssEase: 'linear'
                    }
                }
            ]
        })

        // if (windowWidth > window.breakpoints.mobile) {

            // var slide_array = $('.js_altSlides').data('slides');
            //
            // $.each(slide_array, function (index, slide) {
            //     var slide_html = '<li class="slide">' + (slide['Slideshow Link']['value'] ? '<a ' + (slide['External Link']['value'] == 1 ? 'target="_blank"' : '') +'href="' + slide['Slideshow Link']['value'] + '">' : '') + '<picture><img srcset="/uploads/images/slideshow/' + slide['Slideshow Image']['value'] + '"/></picture>' + (slide['Slideshow Link']['value'] ? '</a>' : '') + '</li>';
            //
            //     $('.js_altSlides').slick('slickAdd', slide_html);
            // });
        // }
    }
}

$(document).ready(function () {
    'use strict';

    slideShow();
    desktopSlider();
    // alternateSlideshow();

}); // document ready */
